import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { resolveProjectAttachments1r3ylk2p3xmwv as resolveProjectAttachments } from '../files/attachmentFilePreview.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { assertNotBlank3rcqh0n27fq5q as assertNotBlank } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { Specification3fgfbf7ihgj8v as Specification } from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get_unitn13b4k6xyo8x as get_unit } from '../../../../../../crowpay-shared/com/crowpay/SpecificationFields.mjs';
import { lensPath16mstx1fbm6dz as lensPath } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../nav/AppDimensions.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  Companion_getInstance2v0f9t0g75gcs as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { bodyBold2czwdzwknab0k as bodyBold } from '../../theming/Titles.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../theming/colorManagement.mjs';
import {
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { weightt34o7llf2uyq as weight } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { MonetaryValueInput2lk8s753hzo22 as MonetaryValueInput } from '../MonetaryValueInput.mjs';
import { errorTextv58wi1t0me7u as errorText } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { nullToBlank2cwx9yazfqg5v as nullToBlank } from '../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { rememberSuspending3qo0upgbry9b as rememberSuspending } from '../../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { renderFiles2vz7gmubfqcvp as renderFiles } from '../files/renderFiles.mjs';
import { fileManager1pvd5zvbyt8nt as fileManager } from '../files/fileManager.mjs';
import { label287uhiq3m9m4z as label2 } from '../label2.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  return LiveApi2$Api2SpecificationLive$uploadFileForRequest$ref_0(tmp$ret$0.vfw().zfg_1);
}
var LiveApi2$Api2SpecificationLive$uploadFileForRequest$refClass;
function LiveApi2$Api2SpecificationLive$uploadFileForRequest$ref() {
  if (LiveApi2$Api2SpecificationLive$uploadFileForRequest$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.qi4_1 = p0;
      }
      uao($completion) {
        return this.qi4_1.lfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2SpecificationLive$uploadFileForRequest$refClass = $;
  }
  return LiveApi2$Api2SpecificationLive$uploadFileForRequest$refClass;
}
function LiveApi2$Api2SpecificationLive$uploadFileForRequest$ref_0(p0) {
  var i = new (LiveApi2$Api2SpecificationLive$uploadFileForRequest$ref())(p0);
  var l = ($completion) => i.uao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $this$rememberSuspending, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ri4_1.si2_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = resolveProjectAttachments(tmp$ret$0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function SpecificationItemForm$_specTitle$lambda(it) {
  return it.v83_1;
}
function SpecificationItemForm$_specTitle$lambda_0(og, it) {
  return og.c84(VOID, VOID, VOID, it);
}
function SpecificationItemForm$_description$lambda(it) {
  return it.w83_1;
}
function SpecificationItemForm$_description$lambda_0(og, it) {
  return og.c84(VOID, VOID, VOID, VOID, it);
}
function SpecificationItemForm$_price$lambda(it) {
  var tmp0_elvis_lhs = it.x83_1;
  var tmp;
  var tmp_0 = tmp0_elvis_lhs;
  if ((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null) {
    tmp = Companion_instance.r91(0n);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return new (MonetaryValue())(tmp);
}
function SpecificationItemForm$_price$lambda_0(og, it) {
  var tmp = it;
  return og.c84(VOID, VOID, VOID, VOID, VOID, tmp == null ? null : tmp.y5r_1);
}
function TextInput$_get_enabled_$ref_3dkh3c(p0) {
  return () => p0.fbs();
}
function TextInput$_set_enabled_$ref_xnynf8(p0) {
  return (_this__u8e3s4) => {
    p0.ebs(_this__u8e3s4);
    return Unit_instance;
  };
}
function MonetaryValueInput$_get_enabled_$ref_ui2o9t(p0) {
  return () => p0.fbs();
}
function MonetaryValueInput$_set_enabled_$ref_7ohxx(p0) {
  return (_this__u8e3s4) => {
    p0.ebs(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextInput$_get_enabled_$ref_3dkh3c_0(p0) {
  return () => p0.fbs();
}
function TextInput$_set_enabled_$ref_xnynf8_0(p0) {
  return (_this__u8e3s4) => {
    p0.ebs(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextArea$_get_enabled_$ref_mw14xh(p0) {
  return () => p0.fbs();
}
function TextArea$_set_enabled_$ref_7ed1ef(p0) {
  return (_this__u8e3s4) => {
    p0.ebs(_this__u8e3s4);
    return Unit_instance;
  };
}
var SpecificationItemForm$render$lambda$slambdaClass;
function SpecificationItemForm$render$lambda$slambda() {
  if (SpecificationItemForm$render$lambda$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    SpecificationItemForm$render$lambda$slambdaClass = $;
  }
  return SpecificationItemForm$render$lambda$slambdaClass;
}
function SpecificationItemForm$render$lambda$slambda_0() {
  var i = new (SpecificationItemForm$render$lambda$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var SpecificationItemForm$render$lambda$slambdaClass_0;
function SpecificationItemForm$render$lambda$slambda_1() {
  if (SpecificationItemForm$render$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.ri4_1 = this$0;
      }
      yah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    SpecificationItemForm$render$lambda$slambdaClass_0 = $;
  }
  return SpecificationItemForm$render$lambda$slambdaClass_0;
}
function SpecificationItemForm$render$lambda$slambda_2(this$0) {
  var i = new (SpecificationItemForm$render$lambda$slambda_1())(this$0);
  var l = ($this$rememberSuspending, $completion) => i.yah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
var SpecificationItemFormClass;
function SpecificationItemForm() {
  if (SpecificationItemFormClass === VOID) {
    class $ {
      constructor(spec, files, allowEditing) {
        allowEditing = allowEditing === VOID ? null : allowEditing;
        this.ri2_1 = spec;
        this.si2_1 = files;
        this.ti2_1 = allowEditing;
        var tmp = this;
        var tmp_0 = SpecificationItemForm$_specTitle$lambda;
        tmp.ui2_1 = assertNotBlank(this.ri2_1.dak(tmp_0, SpecificationItemForm$_specTitle$lambda_0));
        var tmp_1 = this;
        var tmp_2 = SpecificationItemForm$_description$lambda;
        tmp_1.vi2_1 = this.ri2_1.dak(tmp_2, SpecificationItemForm$_description$lambda_0);
        var tmp_3 = this;
        var tmp_4 = SpecificationItemForm$_price$lambda;
        tmp_3.wi2_1 = this.ri2_1.dak(tmp_4, SpecificationItemForm$_price$lambda_0);
        var tmp_5 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_0 = this.ri2_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_6 = serializerOrContextual(createKType(getKClass(Specification()), arrayOf([]), false));
        var tmp$ret$0 = isInterface(tmp_6, KSerializer()) ? tmp_6 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$0);
        var tmp$ret$2 = get_unit(it);
        tmp_5.xi2_1 = lensPath(this_0, tmp$ret$2);
      }
      yi2() {
        return this.ui2_1;
      }
      s91() {
        return this.vi2_1;
      }
      zi2() {
        return this.wi2_1;
      }
      wd6(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint = get_AppDimensions().jg2_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowCollapsingToColumn())(view.pc(), listOf(new (Dimension())(breakpoint)));
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        var tmp = get_expanding(view_0);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label = 'Specification Item Title';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(true);
        view_1.bb9(get_AppDimensions().pg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        view_2.zbm(false);
        view_2.bb9(get_AppDimensions().rg2_1);
        view_2.lbb(get_centered(view_2), bodyBold(view_2, label));
        view_2.lbb(colored(view_2, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_2, '*'));
        view_1.hbb(p_2, view_2);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_0 = view_1.jbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (TextInput())(view_1.pc());
        var tmp0_elvis_lhs_3 = view_1.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
        view_1.gbb(p_3, view_3);
        var tmp0_safe_receiver = this.ti2_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it = tmp0_safe_receiver;
          var tmp_1 = KMutableProperty0();
          var tmp_2 = TextInput$_get_enabled_$ref_3dkh3c(view_3);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('enabled', 0, tmp_1, tmp_2, TextInput$_set_enabled_$ref_xnynf8(view_3));
          reactiveScope(view_3, ($this$reactiveScope) => {
            var tmp$ret$5 = $this$reactiveScope.daj(it);
            this_0.set(tmp$ret$5);
            return Unit_instance;
          });
        }
        view_3.cbs(Companion_getInstance().sd5_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_3.vb5_1.bb4_1.kb7_1.placeholder = 'Title';
        view_3.zah(view_3.icn_1, this.ui2_1);
        view_1.hbb(p_3, view_3);
        view_1.lbb(tmp_0, view_3);
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp, view_1);
        var tmp_3 = get_expanding(view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_4 = view_0.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
        view_0.gbb(p_4, view_4);
        view_4.zbm(false);
        var tmp_4 = weight(view_4, 3.0);
        // Inline function 'com.crowpay.views.components.field2' call
        var label_0 = 'Unit Price (Dollars)';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.gbb(p_5, view_5);
        view_5.zbm(true);
        view_5.bb9(get_AppDimensions().pg2_1);
        bodyBold(view_5, label_0);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_5 = view_5.jbb(FieldSemantic_getInstance());
        // Inline function 'com.crowpay.views.components.monetaryValueInput' call
        // Inline function 'kotlin.also' call
        var this_1 = new (MonetaryValueInput())(view_5);
        var tmp_6 = KMutableProperty0();
        var tmp_7 = MonetaryValueInput$_get_enabled_$ref_ui2o9t(this_1);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_2 = getPropertyCallableRef('enabled', 0, tmp_6, tmp_7, MonetaryValueInput$_set_enabled_$ref_7ohxx(this_1));
        reactiveScope(view_5, ($this$reactiveScope) => {
          var tmp0_safe_receiver = this.ti2_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : $this$reactiveScope.daj(tmp0_safe_receiver);
          var tmp$ret$21 = tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
          this_2.set(tmp$ret$21);
          return Unit_instance;
        });
        this_1.vcl('Price');
        view_5.zah(this_1.ig9_1, this.wi2_1);
        var tmp$ret$26 = this_1.lg9_1;
        view_5.lbb(tmp_5, tmp$ret$26);
        view_5.lbb(view_5.jbb(SubtextSemantic_getInstance()), errorText(view_5));
        view_4.hbb(p_5, view_5);
        view_4.lbb(tmp_4, view_5);
        var tmp_8 = weight(view_4, 1.0);
        // Inline function 'com.crowpay.views.components.field2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(view_4.pc());
        var tmp0_elvis_lhs_6 = view_4.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
        view_4.gbb(p_6, view_6);
        view_6.zbm(true);
        view_6.bb9(get_AppDimensions().pg2_1);
        bodyBold(view_6, 'Unit');
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_9 = view_6.jbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (TextInput())(view_6.pc());
        var tmp0_elvis_lhs_7 = view_6.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
        view_6.gbb(p_7, view_7);
        var tmp0_safe_receiver_0 = this.ti2_1;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_0 = tmp0_safe_receiver_0;
          var tmp_10 = KMutableProperty0();
          var tmp_11 = TextInput$_get_enabled_$ref_3dkh3c_0(view_7);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_3 = getPropertyCallableRef('enabled', 0, tmp_10, tmp_11, TextInput$_set_enabled_$ref_xnynf8_0(view_7));
          reactiveScope(view_7, ($this$reactiveScope) => {
            var tmp$ret$33 = $this$reactiveScope.daj(it_0);
            this_3.set(tmp$ret$33);
            return Unit_instance;
          });
        }
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value = 'E.g "sqft"';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_7.vb5_1.bb4_1.kb7_1.placeholder = value;
        view_7.zah(view_7.icn_1, nullToBlank(this.xi2_1));
        view_6.hbb(p_7, view_7);
        view_6.lbb(tmp_9, view_7);
        view_6.lbb(view_6.jbb(SubtextSemantic_getInstance()), errorText(view_6));
        view_4.hbb(p_6, view_6);
        view_4.lbb(tmp_8, view_6);
        view_0.hbb(p_4, view_4);
        view_0.lbb(tmp_3, view_4);
        view.hbb(p_0, view_0);
        // Inline function 'com.crowpay.views.components.field2' call
        var label_1 = 'Description';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_8 = view.ebb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view : tmp0_elvis_lhs_8;
        view.gbb(p_8, view_8);
        view_8.zbm(true);
        view_8.bb9(get_AppDimensions().pg2_1);
        bodyBold(view_8, label_1);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_12 = view_8.jbb(FieldSemantic_getInstance());
        var tmp_13 = sizeConstraints(view_8, VOID, VOID, get_rem(7));
        // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (TextArea())(view_8.pc());
        var tmp0_elvis_lhs_9 = view_8.ebb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
        view_8.gbb(p_9, view_9);
        var tmp0_safe_receiver_1 = this.ti2_1;
        if (tmp0_safe_receiver_1 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_1 = tmp0_safe_receiver_1;
          var tmp_14 = KMutableProperty0();
          var tmp_15 = TextArea$_get_enabled_$ref_mw14xh(view_9);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_4 = getPropertyCallableRef('enabled', 0, tmp_14, tmp_15, TextArea$_set_enabled_$ref_7ed1ef(view_9));
          reactiveScope(view_9, ($this$reactiveScope) => {
            var tmp$ret$56 = $this$reactiveScope.daj(it_1);
            this_4.set(tmp$ret$56);
            return Unit_instance;
          });
        }
        view_9.vcl('Description');
        view_9.zah(view_9.scl_1, this.vi2_1);
        view_8.hbb(p_9, view_9);
        var tmp$ret$63 = view_8.lbb(tmp_13, view_9);
        view_8.lbb(tmp_12, tmp$ret$63);
        view_8.lbb(view_8.jbb(SubtextSemantic_getInstance()), errorText(view_8));
        view.hbb(p_8, view_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_10 = view.ebb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view : tmp0_elvis_lhs_10;
        view.gbb(p_10, view_10);
        view_10.zbm(true);
        label2(view_10, 'Files (Images, Specs, Info Related to This Item)', VOID, ($this$label2) => {
          var tmp;
          if (this.ti2_1 == null) {
            // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
            var tmp_0 = $this$label2.jbb(FieldSemantic_getInstance());
            tmp = $this$label2.lbb(tmp_0, fileManager($this$label2, this.si2_1, 'No Files Uploaded', VOID, VOID, SpecificationItemForm$render$lambda$slambda_0()));
          } else {
            tmp = renderFiles($this$label2, rememberSuspending(VOID, VOID, VOID, SpecificationItemForm$render$lambda$slambda_2(this)), get_rem(10));
          }
          return tmp;
        });
        view.hbb(p_10, view_10);
        _this__u8e3s4.hbb(p, view);
        return view;
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'SpecificationItemForm', VOID, VOID, [Page()]);
    SpecificationItemFormClass = $;
  }
  return SpecificationItemFormClass;
}
//region block: exports
export {
  SpecificationItemForm as SpecificationItemForm2u6jawyk2khsg,
};
//endregion

//# sourceMappingURL=SpecificationItemForm.mjs.map
